// src/vocabulary/C1/unit4/content.js

const content = {
  level: "C1",
  unit: 4,
  title: "Media, Information & Critical Thinking",
  description:
    "Advanced vocabulary to analyze media, information sources, bias, and critical thinking in modern society.",

  explanation: [
    "This unit focuses on how information is created, shared, and interpreted.",
    "At C1 level, learners must question sources, not just understand them.",
    "Media language often includes bias, persuasion, and framing.",
    "Critical thinking means analyzing information before accepting it.",
    "These words are common in journalism, academia, and public debate.",
    "Learners should distinguish between facts, opinions, and manipulation.",
    "Understanding media language helps avoid misinformation.",
    "Try to question what you read, watch, or hear."
  ],

  items: [
    {
      word: "bias",
      phonetic: "/ˈbaɪəs/",
      meaning: "a systematic predisposition to favor particular perspectives or outcomes, often undermining impartiality and balanced reasoning",
      example: "Confirmation bias leads individuals to seek information that reinforces existing beliefs."
    },
    {
      word: "misinformation",
      phonetic: "/ˌmɪsɪnfəˈmeɪʃn/",
      meaning: "inaccurate or misleading information that circulates widely, often distorting public understanding regardless of deliberate intent",
      example: "The rapid spread of misinformation during crises poses significant risks to public health."
    },
    {
      word: "source",
      phonetic: "/sɔːrs/",
      meaning: "an identifiable origin of information whose authority, methodology, and transparency determine its credibility and reliability",
      example: "Evaluating the credibility of a source is fundamental to responsible information consumption."
    },
    {
      word: "manipulation",
      phonetic: "/məˌnɪpjʊˈleɪʃn/",
      meaning: "the strategic use of deceptive or exploitative tactics to control the perceptions, emotions, or decisions of others",
      example: "Algorithmic manipulation of content can subtly alter political attitudes at scale."
    },
    {
      word: "objective",
      phonetic: "/əbˈdʒektɪv/",
      meaning: "characterized by impartial analysis of evidence without distortion from personal sentiment, ideology, or vested interest",
      example: "Truly objective reporting requires transparency about methods and potential conflicts of interest."
    },
    {
      word: "critical thinking",
      phonetic: "/ˌkrɪtɪkl ˈθɪŋkɪŋ/",
      meaning: "the disciplined cognitive process of rigorously analyzing, evaluating, and synthesizing claims to form independent and well-reasoned judgments",
      example: "Critical thinking is an indispensable skill in navigating an era of information overload."
    }
  ]
};

export default content;
